import React from 'react';
import './app-create-project.css';
import { NotificationManager } from 'react-notifications';
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import services from '../../services';
import { ServiceProjects } from '../../services/service-projects';
import appEnum from '../../util/appEnum';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import Field from '../../components/shared/Field/Field';
import Selector from '../../components/shared/Selector/Selector';
import UserSelector from '../../components/shared/UserSelector/UserSelector';
import { withTranslation } from 'react-i18next';
import { CustomAvatar } from '../../components/shared';
import { TrashIcon } from '../../components/svgs';
import { ServiceUser } from '../../services/service-user';
import { autosave } from '../../util';
import appState from '../../state/AppStateContainer';
import { components } from 'react-select';

const projectSchema = Yup.object().shape({
  name: Yup.string().trim().required('Obligatoriskt'),
  number: Yup.string(),
  customer: Yup.string(),
  province: Yup.object().shape({
    label: Yup.string().required('Obligatoriskt'),
    value: Yup.string().required('Obligatoriskt'),
  }),
  entreprenad: Yup.object().shape({
    label: Yup.string().required('Obligatoriskt'),
    value: Yup.string().required('Obligatoriskt'),
  }),
  estimatedCost: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  projectType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  phase: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  })
});

class AppCreateProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      number: '',
      responsible: '',
      customer: '',
      province: {},
      entreprenad: {},
      estimatedCost: {},
      projectType: {},
      phase: { label: '', value: '' },
      user: {name: '', avatarUrl: ''},
      loaderShow: false,
      dropDownCities: [],
      projectTypes: [],
      dropDownProjectTypes: [],
      entreprenadOptions: [...appEnum.getEntreprenadDataSource(props.t)],
      projectCostOptions: [...appEnum.getProjectCostDataSource()],
    };
  }
  
  async componentDidMount() {
    services.getCities().then(data => {
      let dropDownCities = [];
      data.forEach(item => dropDownCities.push({ label: item, value: item }));
      this.setState({ dropDownCities });
    });
    ServiceProjects.getProjectTypes().then(data => {
      this.setState({
        projectTypes: data,
        dropDownProjectTypes: this.getProjectTypeTranslations(data)
      });
    });
  }

  componentWillUnmount() {
    this.form1 = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.t !== nextProps.t) {
      this.setState({
        entreprenadOptions: [...appEnum.getEntreprenadDataSource(nextProps.t)],
        dropDownProjectTypes: this.getProjectTypeTranslations(this.state.projectTypes)
      });
    }
    var data = nextProps.currentProject;
    if (data && this.props.t !== nextProps.t) {
      this.setState({
        entreprenad: data.entreprenad
          ? {
              value: data.entreprenad,
              label: appEnum.getEntreprenadValueByKey(data.entreprenad, nextProps.t),
            }
          : undefined,
          projectType: data.projectTypeName
          ? {
              label: this.props.t(`projectType.${data.projectTypeName.replace(/[\s&/]/g, '')}`, data.projectTypeName),
              value: data.projectType,
            }
          : {},
      });
    }
    if (data && this.props.currentProject !== data) {
      var newData = {
        _id: data._id,
        slug: data.slug,
        name: data.name,
        number: data.number,
        customer: data.customer,
        province: {
          label: data.province,
          value: data.province,
        },
        entreprenad: data.entreprenad
          ? {
              value: data.entreprenad,
              label: appEnum.getEntreprenadValueByKey(data.entreprenad, nextProps.t),
            }
          : undefined,
        estimatedCost: data.estimatedCost
          ? {
              value: data.estimatedCost,
              label: appEnum.getProjectCostValueByKey(data.estimatedCost),
            }
          : {},
        projectType: data.projectTypeName
          ? {
              label: this.props.t(`projectType.${data.projectTypeName.replace(/[\s&/]/g, '')}`, data.projectTypeName),
              value: data.projectType,
            }
          : {},
        phase: data.phase
          ? {
              label: data.phase,
              value: data.phase,
            }
          : {},
        loaderShow: false,
      };
      this.setState(newData);
    } else if (this.props.showCount !== nextProps.showCount) {
      this.resetDialog();
    }
  }

  getProjectTypeTranslations(data) {
    return data.map(item => ({
      label: this.props.t(`projectType.${item.name.replace(/[\s&/]/g, '')}`, item.name),
      name: item.name,
      value: item._id
    }));
  }



  resetDialog() {
    this.setState({
      _id: '',
      slug: '',
      name: '',
      number: '',
      responsible: '',
      customer: '',
      province: {},
      entreprenad: {},
      estimatedCost: {},
      projectType: {},
      phase: { label: '', value: '' },
      loaderShow: false,
    });
    this.form1?.resetForm();
  }

  btnCreateProjectClickCallback = () => this.form1.submitForm();

  showError = error => <div className="error-show">{error}</div>;

  renderForm() {
    const {t} = this.props;
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const requiredText = t('createProject.validation.required', 'Obligatoriskt');
    const { dropDownCities, entreprenadOptions, projectCostOptions, dropDownProjectTypes } = this.state;

    const renderOption = (value) => (
      value ? <CustomAvatar style={{ marginRight: '10px' }} size="24px" src={value.avatarUrl} alt={value.label} /> : null
    );

    
    const currentUserIfNotSuperadmin = this.props.users.find(u => u.value === appState.getUserId()); 
    const responsible = this.props.currentProject?._id ? this.props.currentProject?.responsible : currentUserIfNotSuperadmin;

    return (
      <div id="create-project-modal">
        <Formik
          ref={ el => { this.form1 = el; } }
          initialValues={{
            name: this.state.name || '',
            number: this.state.number || '',
            customer: this.state.customer || '',
            province: this.state.province || {},
            projectType: this.state.projectType || {},
            entreprenad: this.state.entreprenad,
            estimatedCost: this.state.estimatedCost || {},
            phase: this.state.phase || {},
            responsible: responsible ? {
              label: responsible.name,
              value: responsible._id,
              ...responsible
            } : undefined,
            user: this.props.currentProject?.user ?? (currentUserIfNotSuperadmin ? [currentUserIfNotSuperadmin] : []),
          }}
          onSubmit={this.submitForm}
          validationSchema={
            Yup.object().shape({
              name: Yup.string().trim().required(requiredText),
              number: Yup.string(),
              customer: Yup.string(),
              province: Yup.object().shape({
                label: Yup.string().required(requiredText),
                value: Yup.string().required(requiredText),
              }),
              entreprenad: Yup.object().shape({
                label: Yup.string().required(requiredText),
                value: Yup.string().required(requiredText),
              }),
              estimatedCost: Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
              }),
              projectType: Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
              }),
            })
          }
          enableReinitialize={true}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form>
              <Field
                className='add-project-field'
                errorMessage={errors.name}
                label={t('createProject.label.name', 'Projektnamn')}
                onChange={(value) => setFieldValue("name", value)}
                value={values.name}
                name="name"
                required
              />
              <Field
                className='add-project-field'
                errorMessage={errors.number}
                label={t('createProject.label.projectNo', 'Projektnummer')}
                onChange={(value) => setFieldValue("number", value)}
                value={values.number}
                name="number"
              />

              <Field
                className='add-project-field'
                errorMessage={errors.customer}
                label={t('createProject.label.customer', 'Beställare')}
                onChange={(value) => setFieldValue("customer", value)}
                value={values.customer}
                name="customer"
              />

              <Selector
                label={t('createProject.label.region', 'Kommun')}
                placeholder={t('createProject.placeholder.region', 'Vänligen välj')}
                options={dropDownCities?.map(
                  c => ({
                    value: c.value,
                    label: c.value,
                  })
                )}
                value={values.province}
                onChange={v => setFieldValue('province', v, true)}
                className='add-project-field'
                errorMessage={errors.province && touched.province ? errors.province.value : ""}
                required
              />

              <Selector
                label={t('createProject.label.entreprenad', 'Entreprenadform')}
                placeholder={t('createProject.placeholder.entreprenad', 'Vänligen välj')}
                options={entreprenadOptions?.map(
                  eo => ({
                    value: eo.key,
                    label: eo.value,
                  })
                )}
                value={values.entreprenad}
                onChange={v => setFieldValue('entreprenad', v, true)}
                className='add-project-field'
                errorMessage={errors.entreprenad && touched.entreprenad ? errors.entreprenad.value : ""}
                required
              />

              <Selector
                label={t('createProject.label.estCost', 'Estimerad projektkostnad i MSEK')}
                placeholder={t('createProject.placeholder.estCost', 'Vänligen välj')}
                options={projectCostOptions?.map(
                  pco => ({
                    value: pco.key,
                    label: pco.value,
                  })
                )}
                value={values.estimatedCost}
                onChange={v => setFieldValue('estimatedCost', v, true)}
                className='add-project-field'
                errorMessage={errors.estimatedCost && touched.estimatedCost ? errors.estimatedCost.value : ""}
              />

              <Selector
                label={t('createProject.label.type', 'Projekttyp')}
                placeholder={t('createProject.placeholder.type', 'Vänligen välj')}
                name="projectType"
                options={dropDownProjectTypes?.map(
                  c => ({
                    value: c.value,
                    name: c.name,
                    label: c.label,
                  })
                )}
                value={values.projectType}
                onChange={v => setFieldValue('projectType', v, true)}
                className='add-project-field'
                errorMessage={errors.projectType && touched.projectType ? errors.projectType.value : ""}
              />
              <Selector
                label={t('createProject.label.phase', 'Skede')}
                placeholder={t('createProject.placeholder.phase', 'Vänligen välj')}
                name="phase"
                options={[
                  { label: t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'), value: 'Anbud/Kalkyl' },
                  { label: t('projectPhase.InköpProduktion', 'Inköp/Produktion'), value: 'Inköp/Produktion' }
                ]}
                value={values.phase}
                onChange={v => setFieldValue('phase', v, true)}
                className="add-project-field"
                errorMessage={errors.phase && touched.phase ? errors.phase.value : ''}
              />

              <UserSelector
                label={t('createProject.label.responsible', 'Medarbetare')}
                name="responsible"
                options={this.props.users}
                value={values.responsible ? {
                  label: values.responsible.name, 
                  value: values.responsible._id, 
                  ...values.responsible
                } : null}
                onChange={responsible => {
                  const transformedResponsible = responsible ? {
                    ...responsible,
                    name: responsible.label,
                    _id: responsible.value
                  } : null;
                  setFieldValue('responsible', transformedResponsible);
                }}
                className="add-project-field"
              />
              
              <UserSelector
                isMulti={true}
                label={t('createProject.headline.employees', 'Medarbetare')}
                value={values.user?.map(u => {
                  return ({ label: u.name, value: u._id, ...u });
                }) || []}
                onChange={users => {
                  const transformedUsers = users.map(u => ({
                    ...u,
                    name: u.label,
                    _id: u.value
                  }));
                  setFieldValue('user', transformedUsers);
                }}
                options={this.props.users}
                className="add-project-field"
              />
            </Form>
          )}
        </Formik>
      </div>
    );
  }


  submitForm = async (values, { setSubmitting }) => {
    const {t} = this.props;
    try {
      setSubmitting(true);
      this.setState({ loaderShow: true, ...values });
      let newData = {
        _id: this.state._id,
        slug: this.state.slug,
        name: values.name?.trim(),
        responsible: values.responsible?.value,
        entreprenad: values.entreprenad?.value,
        user: (values.user || []).map(u => u._id),
      };
      
      if (values.province) newData.province = values.province.value;
      if (values.number) newData.number = values.number;
      if (values.customer) newData.customer = values.customer;
      if (values.projectType) {
        newData.projectType = values.projectType.value;
        newData.projectTypeName = values.projectType.name;
      }
      if (values.estimatedCost) newData.estimatedCost = values.estimatedCost?.value;
      if (values.phase?.value) newData.phase = values.phase.value;
      if (values.responsible?.value) { 
        newData.responsible = values.responsible?.value;
      }else{
          newData.responsible = appState.getLoggedInUserDetail().id;
      }
      let response;
      if (this.state._id) {
        response = await ServiceProjects.updateProject(newData);
        var newProject = { ...this.props.currentProject };
        newProject.slug = response.slug;
        newProject.name = response.name;
        newProject.number = response.number;
        newProject.customer = response.customer;
        newProject.province = response.province;
        newProject.projectType = newData.projectType;
        newProject.projectTypeName = newData.projectTypeName;
        newProject.estimatedCost = response.estimatedCost;
        newProject.entreprenad = response.entreprenad;
        newProject.phase = response.phase;
        newProject.responsible = values.responsible || '';
        newProject.user = values.user || [];
        response = newProject;
        ServiceProjects.replaceDataItem(response);
        response.isEdit = true;
        NotificationManager.success(t('createProject.notification.success.updated','Projektet har uppdaterats'))
      } else {
        response = await ServiceProjects.addProject(newData);
        response.user = values.user || [];
        response.responsible = values.responsible || '';
        ServiceProjects.add(response);
        response.isEdit = false;
        NotificationManager.success(t('createProject.notification.success.created', 'Projektet har skapats'))
      }

      // Update project members in one call
      const projectId = response._id || this.state._id;
      const userIds = (values.user || []).map(u => u._id || u.value);
      await ServiceUser.updateProjectMembers(projectId, userIds);

      if (this.props.onProjectUpdateCreated) {
        this.props.onProjectUpdateCreated(this, response);
      }
    } catch (e) {
      console.error('error', e);
      NotificationManager.error(
        t(
          `notification.error.description.${e?.response?.data?.error || 'unexpected'}`,
          'Oväntat fel ({{error}})',
          { error: e?.response?.data?.error || 'unexpected' }
        ),
        t('createProject.notification.error.title', 'Misslyckat')
      );
    } finally {
      this.setState({ loaderShow: false });
      setSubmitting(false);
    }
  };

  onClose = () => this.props?.onClose();

  render() {
    return (
      <div className="app-add-supplier app-create-project" ref={el => (this.element = el)}>
        <div className="page-paddings">
          <BtGrid>
            <BtRow>
              <BtColumn className="colum-left pp-col-left">
                <div className="content-left">{this.renderForm()}</div>
              </BtColumn>
            </BtRow>
          </BtGrid>
        </div>
      </div>
    );
  }
}

export default withTranslation('projects', { withRef: true })(AppCreateProject);
